import React, { useEffect, useMemo, useState } from 'react';
import { useEnvironment, useHelmet, useSnackbar } from '../../hooks';
import { Filters, IApplyFilters } from './components/filters';
import { useInvoicesListGql } from './graphql/invoices';
import Log from '../../controllers/log';
import Cookies from 'universal-cookie';
import { Table } from 'components/migrated/table';
import columns from './components/table/columns';
import { useStyles } from './styles';
import { Button, CircularProgress } from '@material-ui/core';
import { constructInvoiceNFELink } from './util/constructNFSELink';

export const Invoices = () => {
  const { TITLE, DEBUG } = useEnvironment();
  useHelmet({ title: `${TITLE} - Pagamentos` });
  const classes = useStyles();
  const { toggleSnackbar } = useSnackbar();

  const [invoiceTypeFilter, setInvoiceTypeFilter] = useState('');

  const { runInvoicesListGql, dataInvoicesList, cityHallSite, cityHallNfs, errorInvoicesList, loadingInvoicesList } =
    useInvoicesListGql();

  const handleDate = (date: Date) => {
    return date.toLocaleDateString('pt-BR').toString();
  };

  const handleCurrency = new Intl.NumberFormat('pt-BR', {
    currency: 'BRL',
    style: 'currency'
  });

  const invoices = useMemo(
    () =>
      dataInvoicesList.map((invoice) => {
        const invoiceLink = constructInvoiceNFELink({
          cityHallNfs,
          providerDocumentId: invoice.providerDocumentId,
          invoiceKeyCode: invoice.invoiceKeyCode,
          nrNfeServico: invoice.nrNfeServico
        });

        return {
          ...invoice,
          invoiceLink,
          netValue: handleCurrency.format(invoice.netValue),
          totalAmount: handleCurrency.format(invoice.totalAmount)
        };
      }),
    [dataInvoicesList, cityHallNfs]
  );

  const handleLoadData = (args: IApplyFilters) => {
    const startIssueDate = handleDate(args.startDate);
    const endIssueDate = handleDate(args.endDate);
    const personId = parseInt(args.supplier);
    const invoiceTypeFilter = args.invoiceType;
    setInvoiceTypeFilter(invoiceTypeFilter);
    runInvoicesListGql({
      variables: {
        endIssueDate,
        initialRow: 0,
        invoiceTypeFilter,
        nextRows: 5000,
        personId,
        startIssueDate
      }
    });
  };

  const handleLog = () => {
    const cookies = new Cookies();
    const token = cookies.get('User-Token');
    Log.info(token, 'Efetuado carregamento da tela Notas!');
  };

  useEffect(() => {
    handleLog();
  }, []);

  useEffect(() => {
    if (errorInvoicesList) {
      if (DEBUG === 'TRUE') {
        console.log(`Erro ao carregar dados! Error:(message: ${errorInvoicesList} )`);
      } else {
        toggleSnackbar({
          message: 'Ocorreu um problema ao carregar os dados. Por favor, informe ao suporte.',
          type: 'error'
        });
      }
    }
  }, [errorInvoicesList]);

  const handleOpenNfeDownload = () => {
    const win = window.open(cityHallSite, '_blank');

    if (win) win.focus();
  };

  return (
    <div className="container">
      <Filters onApplyFilters={(args) => handleLoadData(args)} />

      {!loadingInvoicesList && (
        <>
          <Table
            columns={dataInvoicesList.length > 0 ? columns(invoiceTypeFilter) : []}
            data={invoices}
            title="Nota Fiscal"
          />
          {invoiceTypeFilter === 'U' && cityHallSite && (
            <div>
              <Button color="primary" variant="contained" onClick={handleOpenNfeDownload}>
                Consulte a Nota Fiscal Eletrônica
              </Button>
            </div>
          )}
        </>
      )}

      {loadingInvoicesList && (
        <div className={classes.loader}>
          <CircularProgress />
        </div>
      )}
    </div>
  );
};
